import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4fd77bea&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4fd77bea&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd77bea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fd77bea')) {
      api.createRecord('4fd77bea', component.options)
    } else {
      api.reload('4fd77bea', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4fd77bea&scoped=true", function () {
      api.rerender('4fd77bea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/setting/enterprise/upgrade/index.vue"
export default component.exports